<p-card *ngIf="data">
    <div class="p-fluid p-grid">
        <div class="p-col-12">
            <p-carousel
                [value]="images"
                [numVisible]="1"
                [numScroll]="1"
                [circular]="true"
                [autoplayInterval]="3000"
            >
                <ng-template let-item pTemplate="item">
                    <div class="item">
                        <div class="item-content">
                            <div class="p-mb-3">
                                <a href="{{ item.url }}" target="_blank" class="item" [ngStyle]="item.styles">
                                </a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-carousel>
        </div>
    </div>
</p-card>
